const PromoCodeIcon = () => (
  <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <radialGradient id="promo-code-icon-grad" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(8.75 12) rotate(-36.7475) scale(23.4001 29.2501)">
        <stop stopColor="var(--s247-icon-start, #EE5B33)"/>
        <stop offset="1" stopColor="var(--s247-icon-end, #AA258D)"/>
      </radialGradient>
    </defs>
    <path d="M2 0C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V6C0.530433 6 1.03914 6.21071 1.41421 6.58579C1.78929 6.96086 2 7.46957 2 8C2 8.53043 1.78929 9.03914 1.41421 9.41421C1.03914 9.78929 0.530433 10 0 10V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H18C18.5304 16 19.0391 15.7893 19.4142 15.4142C19.7893 15.0391 20 14.5304 20 14V10C19.4696 10 18.9609 9.78929 18.5858 9.41421C18.2107 9.03914 18 8.53043 18 8C18 7.46957 18.2107 6.96086 18.5858 6.58579C18.9609 6.21071 19.4696 6 20 6V2C20 1.46957 19.7893 0.960859 19.4142 0.585786C19.0391 0.210714 18.5304 0 18 0H2ZM13.5 3L15 4.5L6.5 13L5 11.5L13.5 3ZM6.81 3.04C7.79 3.04 8.58 3.83 8.58 4.81C8.58 5.27943 8.39352 5.72964 8.06158 6.06158C7.72964 6.39352 7.27943 6.58 6.81 6.58C5.83 6.58 5.04 5.79 5.04 4.81C5.04 4.34057 5.22648 3.89036 5.55842 3.55842C5.89036 3.22648 6.34057 3.04 6.81 3.04ZM13.19 9.42C14.17 9.42 14.96 10.21 14.96 11.19C14.96 11.6594 14.7735 12.1096 14.4416 12.4416C14.1096 12.7735 13.6594 12.96 13.19 12.96C12.21 12.96 11.42 12.17 11.42 11.19C11.42 10.7206 11.6065 10.2704 11.9384 9.93842C12.2704 9.60648 12.7206 9.42 13.19 9.42Z" fill="url(#promo-code-icon-grad)"/>
  </svg>
);
import Section from 'Components/Section';
import { C2cOverPaymentTextEnum } from 'Pages/C2cOrderPayment/enums';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './styles.scss';
import InputMessage from 'Components/InputMessage';
import InputText from 'Components/InputText';
import PromotionModal from 'Pages/PromotionVoucher/PromotionModal';
import { useSelector } from 'react-redux';
import { c2cOrderPaymentSelectors, chooseVoucherAction } from 'Stores/c2c-order-payment';
import ButtonClick from 'Components/ButtonClick';
import { useDispatch } from 'react-redux';

const C2cPromoCode = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const [visiblePromotionModal, setVisiblePromotionModal] = useState(false);
	const selectedVoucher = useSelector(
		c2cOrderPaymentSelectors.get,
	).voucherSelected;
	const voucherValidationResult = useSelector(
		c2cOrderPaymentSelectors.get,
	).voucherValidation;
	const { vouchers } = useSelector(c2cOrderPaymentSelectors.get);

	const showVoucherList = () => {
		setVisiblePromotionModal(true);
	};

	const removeVoucher = () => {
		dispatch(chooseVoucherAction({}))
	}

	return (
		<Section
			className="c2c-promo-code"
			title={
				<div className="c2c-promo-code-title">
					<span className="c2c-promo-code-title-text">
						<span style={{ marginRight: '10px', display: 'inline-flex' }}><PromoCodeIcon /></span>
						{t(C2cOverPaymentTextEnum.C2cPromoCode_Title)}
					</span>
					{vouchers.length > 0 && (
						<span className="c2c-promo-code-title-sub">
					{t(
						C2cOverPaymentTextEnum.C2cPromoCode_AvailableInfo,
						{ count: vouchers.length }
					)}
				</span>
					)}
				</div>
			}
		>
			<div className="c2c-promo-code-input-wrap">
				<InputText
					readOnly={true}
					className="c2c-promo-code-input"
					value={selectedVoucher?.code}
					name="c2c-promo-code"
					placeholder={t(
						C2cOverPaymentTextEnum.C2cPromo_PlaceHolderInput,
					)}
					onClick={showVoucherList}
					suffix={
						selectedVoucher?.code ? (
							<ButtonClick className={'c2c-promo-code-input-delete-btn'} variant="link" onClick={removeVoucher}>
								{t(
									C2cOverPaymentTextEnum.C2cPromoCode_BtnDeleteVoucher,
								)}
							</ButtonClick>
						) : (
							<></>
						)
					}
				/>
			</div>
			<div className={'mt-2'}>
				{selectedVoucher?.code &&
					voucherValidationResult &&
					voucherValidationResult.status && (
						<InputMessage
							message={t(voucherValidationResult.message || '')}
							type={
								voucherValidationResult.status === 'checking'
									? 'info'
									: voucherValidationResult.status
							}
						/>
					)}
			</div>
			{ (
				<PromotionModal
					visible={visiblePromotionModal}
					onClose={() => setVisiblePromotionModal(false)}
				/>
			)}
		</Section>
	);
};

export default C2cPromoCode;
